import React from "react";
import PropTypes from "prop-types";
import { Component } from "react";
import C from "../../../constants";
import HelperContent from "../../helperContent/HelperContent";
import QuestionLabel from "../../question/QuestionLabel";
import QuestionOption from "../../question/QuestionOption";
import Footer from "../../Footer";
import { generate } from "random-words";
import { has } from "lodash";

class CodeWordGenerator extends Component {
    componentDidMount() {
        let result = generate({ exactly: 1, wordsPerString: 3, minLength: 5 });

        localStorage.setItem("attestivCodeWordPhrase", result[0]);

        this.props.store.dispatch({ type: C.STORE_RESULT_DATA, result: result[0] });
    }

    render() {
        let question = this.props.question;
        let store = this.props.store;
        let className = "w3-panel w3-opacity" + (has(question, "class") ? " " + question.class : " w3-large w3-center");

        let options = question.options;
        let optionsCode = null;
    
        if (options && options.length > 0) {
            optionsCode = (
                <ul className="w3-ul w3-border w3-padding-small w3-margin-top">
                    {options.map(option => (
                        <li className="question-option w3-xlarge w3-center" key={option.itemID}>
                            <QuestionOption option={option} onClick={() => this.props.selectionMade(option)} />
                        </li>
                    ))}
                </ul>
            );
        }

        return (
            <div className="form w3-header w3-animate-opacity">
                <QuestionLabel question={question} store={store}/>
                <HelperContent question={question} />
                <div id={question.questionID} className={className} dangerouslySetInnerHTML={{__html: localStorage.getItem("attestivCodeWordPhrase")}}></div>
                <div className="question-options">{optionsCode}</div>
                <Footer question={question}/>
            </div>
        )
    }
};

CodeWordGenerator.propTypes = {
    question: PropTypes.object,
    store: PropTypes.object
};

export default CodeWordGenerator;
